<template>
  <vue-toggles
    v-if="editable"
    ref="toggle"
    class="mb-3"
    :value="value"
    @click="$emit('input', !$event)"
    :aria-label="label"
    checkedText="Yes"
    checkedColor="white"
    checkedBg="#3F7D5F"
    uncheckedText="No"
    uncheckedColor="white"
    uncheckedBg="#6E6E6E"
    fontSize="14"
    fontWeight="600"
  />
  <p class="my-5" v-else>{{ value ? 'Yes' : 'No' }}</p>
</template>

<script>
import VueToggles from 'vue-toggles';
export default {
  components: { VueToggles },
  // vue-toggles renders role="switch" with no name of its own (WCAG SC 4.1.2). The
  // unchecked state also drew white "No" text on a pale default background; #6E6E6E gives
  // 5.10:1 (SC 1.4.3).
  props: {
    value: { type: [Boolean, Number, String], default: false },
    editable: { type: Boolean, default: true },
    label: { type: String, default: 'Yes or no' },
  },
  mounted() {
    this.exposeStateText();
  },
  updated() {
    this.exposeStateText();
  },
  methods: {
    // vue-toggles puts aria-hidden="true" on the knob, which also hides the visible
    // "Yes"/"No" text from screen readers (audit 13.2). Only the current state's text is
    // displayed (the other is display:none), so exposing it is safe.
    exposeStateText() {
      const toggle = this.$refs.toggle && this.$refs.toggle.$el;
      const dot = toggle && toggle.querySelector('.dot[aria-hidden]');
      if (dot) dot.removeAttribute('aria-hidden');
    },
  },
};
</script>
